import { useTranslation } from '@dreamstack/i18n'
import type { FunctionComponent } from 'react'
import { PieChart } from '../PieChart'
import { POPULATION_BY_NATIONALITY } from './data/bevoelkerung_nach_nationalität'
import { useDataForPieChart } from './libs/useDataForPieChart'

export interface RegionPieChartProps {
  customProps: RegionPieChartCustomProps
}

export type RegionPieChartCustomProps = {
  region: string
}

export const RegionPieChart: FunctionComponent<
  React.PropsWithChildren<RegionPieChartProps>
> = ({ customProps }) => {
  const region = customProps.region
  const t = useTranslation()
  const raw_data = POPULATION_BY_NATIONALITY
  const { parsedTop5PopulationData, parsedPopulationData } = useDataForPieChart(
    region,
    raw_data
  )

  if (region) {
    return (
      <div className="col-span-full bg-accentroAqua-100 h-auto lg:col-start-3 lg:col-span-8  px-px-24 py-px-32 md:px-px-48">
        <div className="h-auto grid grid-cols-1 md:grid-cols-2 space-y-16 md:space-y-0">
          <div className="h-px-576">
            <div className="text-left pl-px-20 text-px-20 font-semibold w-full h-auto md:h-px-64 pb-px-24">
              {t('accentro:districtLandingPageGraphs.regionPieChart.residents')}{' '}
              {region}
            </div>
            <PieChart
              data={parsedPopulationData}
              colors={['#45627B', '#ABB4D1', '#704A71', '#B6A6BA']}
            />
          </div>
          <div className="h-px-576">
            <div className="text-right pr-px-20 text-px-20 font-semibold  w-full pb-px-24 h-auto md:h-px-64">
              {t(
                'accentro:districtLandingPageGraphs.regionPieChart.fiveLargestInternational'
              )}{' '}
              {region}
            </div>
            <PieChart
              data={parsedTop5PopulationData}
              colors={['#45627B', '#B6A6BA', '#ABB4D1', '#778AA6', '#704A71']}
              labelsAreRight
            />
          </div>
        </div>
      </div>
    )
  } else
    return (
      <>
        {t(
          'accentro:districtLandingPageGraphs.regionPieChart.mustSelectRegion'
        )}
      </>
    )
}
